import React from 'react';
import { withUnmountWhenHidden } from './hocs';

const SpinnerBase = () => <i className="fa fa-spinner fa-spin" aria-hidden="true" />;

export const Spinner = withUnmountWhenHidden(SpinnerBase);
